import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { CustomIcon } from './CustomIcon'
import { SystemIcon } from './SystemIcon'
import { withOutboundLink } from 'LiveBoard/hocs'
import { isEnterKey } from 'shared/helpers/AccessibilityHelper'
import { CTA_AREAS, LINK_TYPES, LINK_TARGETS } from 'LiveBoard/components/shared/CallToAction/constants'
import get from 'lodash/get'

import './style.css.scss'

const PromotionItem = (props) => {
  useEffect(() => {
    const url = get(props.item, 'url')
    url && props.setOutboundUrlAttribute(url)
  },[])

  const handleClick = () => {
    props.item.url && props.onOpenOutboundLink(
      props.item.url,
      LINK_TARGETS[LINK_TYPES.newTab],
      {
        area: CTA_AREAS.promotion
      }
    )
  }

  const onKeyboardClick = (e) => {
    isEnterKey(e) && handleClick(e)
  }

  return (
    <div onKeyDown={onKeyboardClick} >
      { props.showIcons &&
        (props.item.is_image
        ? <CustomIcon
            iconSizeClass={props.iconSizeClass}
            onClick={handleClick}
            linkUrl={props.item.url}
            image={get(props.item, 'image')} />
        : <SystemIcon
            onClick={handleClick}
            linkUrl={props.item.url}
            icon={props.item.icon}
            themeColorHex={props.themeColorHex}
            iconSizeClass={props.iconSizeClass} />)
      }
      <div className="promotion-item-text">
        { props.item.title && (
            <h2
              onClick={handleClick}
              style={{ color: props.themeColorHex }}>
              {props.item.title}
            </h2>
        )}
        { props.item.text && <p>{props.item.text}</p> }
      </div>
    </div>
  )
}

PromotionItem.propTypes = {
  item: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  itemInRowClass: PropTypes.string.isRequired,
  textAlignmentClass: PropTypes.string,
  iconSizeClass: PropTypes.string
}

export default withOutboundLink(PromotionItem)